import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { confirmState, contactType } from 'utils/constant';
import GrayBox from 'components/container/GrayBox';
import LargeModal from 'components/form/LargeModal';
import VerticalTable from 'components/table/VerticalTable';
import DefaultTextArea from 'components/input/DefaultTextArea';
import DefaultRadio from 'components/input/DefaultRadio';
import SubmitButton from 'components/button/SubmitButton';
import { contactUsDetail, contactUsUpdate } from 'apis/operation/contactUsApis';

/**
 *
 * @returns {문의하기 상세 조회 & 수정 모달}
 */
const ContactUsUpdateModal = ({ visible, setVisible, record, fetchData }) => {
  const [updateData, setUpdateData] = useState({
    inquiry_no: -1,
    state: 0,
    memo: '',
  });
  const [detailData, setDetailData] = useState();

  /// 문의사항 상태 유무
  const handleChangeState = (e) => {
    setUpdateData({ ...updateData, state: e.target.value });
  };

  /// 문의사항 답변 내용
  const handleInputMemo = (e) => {
    setUpdateData({ ...updateData, memo: e.target.value });
  };
  const handleClose = () => {
    setVisible(false);
  };

  const handleSubmit = async () => {
    const res = await contactUsUpdate(updateData);
    // console.log(res);
    fetchData();
    setVisible(false);
    updateData({ inquiry_no: -1, state: 0, memo: '' });
    message.success('문의사항 답변 정보가 수정되었습니다. ', 1);
  };
  const fetchDetailData = async () => {
    const res = await contactUsDetail(record?.inquiry_no);
    // console.log(res);
    setDetailData(res[0]);
    setUpdateData({
      ...updateData,
      inquiry_no: record?.inquiry_no,
      state: res[0]?.state,
      memo: res[0]?.memo,
    });
  };
  useEffect(() => {
    if (record) {
      fetchDetailData().catch(console.log);
    }
  }, []);
  return (
    <LargeModal
      title='문의하기 상세보기'
      visible={visible}
      onCancel={handleClose}
    >
      <div className='input_wrap'>
        <GrayBox left style={{ height: '20rem' }}>
          <VerticalTable>
            <>
              <tr key='0'>
                <th>이름</th>
                <td>{detailData?.client}</td>
              </tr>
              <tr key='1'>
                <th>기업명</th>
                <td>{detailData?.company}</td>
              </tr>
              <tr key='2'>
                <th>작성 일자</th>
                <td>{detailData?.create_date}</td>
              </tr>
              <tr key='3'>
                <th>타입</th>
                <td>
                  {contactType?.map(
                    (v) => v.value === detailData?.kind && v.text,
                  )}
                </td>
              </tr>
              <tr key='4'>
                <th>문의 내용</th>
                <td>
                  <DefaultTextArea value={detailData?.contents} allowClear />
                </td>
              </tr>
            </>
          </VerticalTable>
        </GrayBox>
        <GrayBox style={{ height: '20rem' }}>
          <VerticalTable>
            <>
              <tr>
                <th>확인 유무</th>
                <td>
                  <DefaultRadio
                    name='state'
                    optionList={confirmState}
                    onChange={handleChangeState}
                    defaultValue={updateData?.state}
                  />
                </td>
              </tr>
              <tr>
                <th>처리 방법</th>
                <td>
                  <DefaultTextArea
                    value={updateData?.memo}
                    onChange={handleInputMemo}
                  />
                </td>
              </tr>
            </>
          </VerticalTable>
        </GrayBox>
      </div>
      <div className='button_wrap'>
        <SubmitButton onClick={handleSubmit}>수정하기</SubmitButton>
      </div>
    </LargeModal>
  );
};

export default ContactUsUpdateModal;
